(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileDeleteController',IndicatorFileDeleteController);

    IndicatorFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'IndicatorFile'];

    function IndicatorFileDeleteController($uibModalInstance, entity, IndicatorFile) {
        var vm = this;

        vm.indicatorFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IndicatorFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
